// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"11ba095d","84":"244441d1","126":"96efea8a","182":"bae09e2f","229":"317c8901","247":"8d1fe861","468":"7a360fc1","472":"c93ee5c2","551":"2e21c761","627":"fd924a3f","828":"0cae8653","834":"bb98e331","867":"57819bb2","923":"481cf3e3","950":"e5763eed"}[chunkId] + ".chunk.js";
};